import { AssetFieldMapping } from '../../../store/OutsideInventory';

export const DEFAULT_ASSET_FIELD_MAPPINGS: AssetFieldMapping[] = [
  {
    assetField: 'Account',
    assetFieldKey: 'account_id',
    portalField: 'Account',
    portalFieldKey: 'account_id',
    required: true
  },
  {
    assetField: 'Supplier',
    assetFieldKey: 'supplier_id',
    portalField: 'Supplier',
    portalFieldKey: 'supplier_id',
    required: true
  },
  {
    assetField: 'Product',
    assetFieldKey: 'product_id',
    portalField: 'Product',
    portalFieldKey: 'product_id',
    required: true
  },
  {
    assetField: 'Address',
    assetFieldKey: 'address',
    portalField: 'Address',
    portalFieldKey: 'address',
    required: false
  },
  {
    assetField: 'Speed',
    assetFieldKey: 'speed',
    portalField: 'Speed',
    portalFieldKey: 'speed',
    required: false
  },
  {
    assetField: 'Billing Frequency',
    assetFieldKey: 'billing_frequency',
    portalField: 'Billing Frequency',
    portalFieldKey: 'billingFrequency',
    required: false
  },
  {
    assetField: 'Circuit IDs',
    assetFieldKey: 'circuitIDs',
    portalField: 'Circuit IDs',
    portalFieldKey: 'circuitIDs',
    required: false
  },
  {
    assetField: 'Circuit Type',
    assetFieldKey: 'circuitType',
    portalField: 'Circuit Type',
    portalFieldKey: 'circuitType',
    required: false
  },
  {
    assetField: 'Contract End Date',
    assetFieldKey: 'contractEndDate',
    portalField: 'Contract End Date',
    portalFieldKey: 'contractEndDate',
    required: false
  },
  {
    assetField: 'Status',
    assetFieldKey: 'status',
    portalField: 'Status',
    portalFieldKey: 'status',
    required: false
  },
  {
    assetField: 'Monthly Recurring Cost',
    assetFieldKey: 'mRC',
    portalField: 'MRC',
    portalFieldKey: 'mRC',
    required: false
  },
  {
    assetField: 'Non-Recurring Cost',
    assetFieldKey: 'nRC',
    portalField: 'NRC',
    portalFieldKey: 'nRC',
    required: false
  },
  {
    assetField: 'Term',
    assetFieldKey: 'term',
    portalField: 'Term',
    portalFieldKey: 'term',
    required: false
  },
  {
    assetField: 'Order Type',
    assetFieldKey: 'orderType',
    portalField: 'Order Type',
    portalFieldKey: 'orderType',
    required: false
  },
  {
    assetField: 'Provider Account Number',
    assetFieldKey: 'providerAccountNumber',
    portalField: 'Provider Account Number',
    portalFieldKey: 'providerAccountNumber',
    required: false
  },
  {
    assetField: 'Supplier Order Number',
    assetFieldKey: 'supplierOrderNumber',
    portalField: 'Supplier Order Number',
    portalFieldKey: 'supplierOrderNumber',
    required: false
  },
  {
    assetField: 'Service Activation Date',
    assetFieldKey: 'serviceActivationDate',
    portalField: 'Service Activation Date',
    portalFieldKey: 'serviceActivationDate',
    required: false
  },
  {
    assetField: 'Completion Date',
    assetFieldKey: 'completionDate',
    portalField: 'Completion Date',
    portalFieldKey: 'completionDate',
    required: false
  },
  {
    assetField: 'Disconnected Date',
    assetFieldKey: 'disconnectedDate',
    portalField: 'Disconnected Date',
    portalFieldKey: 'disconnectedDate',
    required: false
  },
  {
    assetField: 'Connectivity A',
    assetFieldKey: 'connectivityA',
    portalField: 'Connectivity A',
    portalFieldKey: 'connectivityA',
    required: false
  },
  {
    assetField: 'Connectivity B',
    assetFieldKey: 'connectivityB',
    portalField: 'Connectivity B',
    portalFieldKey: 'connectivityB',
    required: false
  },
  {
    assetField: 'Equipment Manufacturer',
    assetFieldKey: 'equipmentManufacturer',
    portalField: 'Equipment Manufacturer',
    portalFieldKey: 'equipmentManufacturer',
    required: false
  },
  {
    assetField: 'Equipment Type',
    assetFieldKey: 'equipmentType',
    portalField: 'Equipment Type',
    portalFieldKey: 'equipmentType',
    required: false
  },
  {
    assetField: 'First Invoice Reviewed By Date',
    assetFieldKey: 'firstInvoiceReviewedByDate',
    portalField: 'First Invoice Reviewed By Date',
    portalFieldKey: 'firstInvoiceReviewedByDate',
    required: false
  },
  {
    assetField: 'IP Details',
    assetFieldKey: 'iPDetails',
    portalField: 'IP Details',
    portalFieldKey: 'iPDetails',
    required: false
  },
  {
    assetField: 'KW Rack',
    assetFieldKey: 'kwRack',
    portalField: 'KW Rack',
    portalFieldKey: 'kwRack',
    required: false
  },
  {
    assetField: 'LEC Circuit ID',
    assetFieldKey: 'lecCircuitID',
    portalField: 'LEC Circuit ID',
    portalFieldKey: 'lecCircuitID',
    required: false
  },
  {
    assetField: 'LEC Demarc',
    assetFieldKey: 'lecDemarc',
    portalField: 'LEC Demarc',
    portalFieldKey: 'lecDemarc',
    required: false
  },
  {
    assetField: 'Access Provider',
    assetFieldKey: 'accessProvider',
    portalField: 'Access Provider',
    portalFieldKey: 'accessProvider',
    required: false
  },
  {
    assetField: 'Location A LEC Circuit ID',
    assetFieldKey: 'locationALecCircuitId',
    portalField: 'Location A LEC Circuit ID',
    portalFieldKey: 'locationALecCircuitId',
    required: false
  },
  {
    assetField: 'Location A LEC Demarc',
    assetFieldKey: 'locationALecDemarc',
    portalField: 'Location A LEC Demarc',
    portalFieldKey: 'locationALecDemarc',
    required: false
  },
  {
    assetField: 'Location A Local LEC',
    assetFieldKey: 'locationALocalLec',
    portalField: 'Location A Local LEC',
    portalFieldKey: 'locationALocalLec',
    required: false
  },
  {
    assetField: 'Location A Text',
    assetFieldKey: 'locationAText',
    portalField: 'Location A Text',
    portalFieldKey: 'locationAText',
    required: false
  },
  {
    assetField: 'Location Z LEC Circuit ID',
    assetFieldKey: 'locationZLecCircuitId',
    portalField: 'Location Z LEC Circuit ID',
    portalFieldKey: 'locationZLecCircuitId',
    required: false
  },
  {
    assetField: 'Location Z LEC Demarc',
    assetFieldKey: 'locationZLecDemarc',
    portalField: 'Location Z LEC Demarc',
    portalFieldKey: 'locationZLecDemarc',
    required: false
  },
  {
    assetField: 'Location Z Local LEC',
    assetFieldKey: 'locationZLocalLec',
    portalField: 'Location Z Local LEC',
    portalFieldKey: 'locationZLocalLec',
    required: false
  },
  {
    assetField: 'Location Z Text',
    assetFieldKey: 'locationZText',
    portalField: 'Location Z Text',
    portalFieldKey: 'locationZText',
    required: false
  },
  {
    assetField: 'Phone Numbers',
    assetFieldKey: 'phoneNumbers',
    portalField: 'Phone Numbers',
    portalFieldKey: 'phoneNumbers',
    required: false
  },
  {
    assetField: 'Product Support Number',
    assetFieldKey: 'productSupportNumber',
    portalField: 'Product Support Number',
    portalFieldKey: 'productSupportNumber',
    required: false
  },
  {
    assetField: 'Supplier Support Number',
    assetFieldKey: 'supplierSupportNumber',
    portalField: 'Supplier Support Number',
    portalFieldKey: 'supplierSupportNumber',
    required: false
  },
  {
    assetField: 'Supplier Support URL',
    assetFieldKey: 'supplierSupportURL',
    portalField: 'Supplier Support URL',
    portalFieldKey: 'supplierSupportURL',
    required: false
  },
  {
    assetField: 'Network Details',
    assetFieldKey: 'networkDetails',
    portalField: 'Network Details',
    portalFieldKey: 'networkDetails',
    required: false
  },
  {
    assetField: 'Device Details',
    assetFieldKey: 'deviceDetails',
    portalField: 'Device Details',
    portalFieldKey: 'deviceDetails',
    required: false
  },
  {
    assetField: 'Enclosure',
    assetFieldKey: 'enclosure',
    portalField: 'Enclosure',
    portalFieldKey: 'enclosure',
    required: false
  },
  {
    assetField: 'Floor',
    assetFieldKey: 'floor',
    portalField: 'Floor',
    portalFieldKey: 'floor',
    required: false
  },
  {
    assetField: 'FOC Date',
    assetFieldKey: 'focDate',
    portalField: 'FOC Date',
    portalFieldKey: 'focDate',
    required: false
  },
  {
    assetField: 'License Quantity',
    assetFieldKey: 'licenseQuantity',
    portalField: 'License Quantity',
    portalFieldKey: 'licenseQuantity',
    required: false
  },
  {
    assetField: 'License Expiration Date',
    assetFieldKey: 'licenseExpirationDate',
    portalField: 'License Expiration Date',
    portalFieldKey: 'licenseExpirationDate',
    required: false
  },
  {
    assetField: 'Metered',
    assetFieldKey: 'metered',
    portalField: 'Metered',
    portalFieldKey: 'metered',
    required: false
  },
  {
    assetField: 'Model',
    assetFieldKey: 'model',
    portalField: 'Model',
    portalFieldKey: 'model',
    required: false
  },
  {
    assetField: 'Mount',
    assetFieldKey: 'mount',
    portalField: 'Mount',
    portalFieldKey: 'mount',
    required: false
  },
  {
    assetField: 'Network Type',
    assetFieldKey: 'networkType',
    portalField: 'Network Type',
    portalFieldKey: 'networkType',
    required: false
  },
  {
    assetField: 'PDU Phase',
    assetFieldKey: 'pduPhase',
    portalField: 'PDU Phase',
    portalFieldKey: 'pduPhase',
    required: false
  },
  {
    assetField: 'Power Type',
    assetFieldKey: 'powerType',
    portalField: 'Power Type',
    portalFieldKey: 'powerType',
    required: false
  },
  {
    assetField: 'Download Speed Mbps',
    assetFieldKey: 'downloadSpeedMbps',
    portalField: 'Download Speed Mbps',
    portalFieldKey: 'downloadSpeedMbps',
    required: false
  },
  {
    assetField: 'Upload Speed Mbps',
    assetFieldKey: 'uploadSpeedMbps',
    portalField: 'Upload Speed Mbps',
    portalFieldKey: 'uploadSpeedMbps',
    required: false
  },
  {
    assetField: 'Voice Type',
    assetFieldKey: 'voiceType',
    portalField: 'Voice Type',
    portalFieldKey: 'voiceType',
    required: false
  },
  {
    assetField: 'Project ID',
    assetFieldKey: 'projectId',
    portalField: 'Project ID',
    portalFieldKey: 'projectId',
    required: false
  },
  {
    assetField: 'Project SF ID',
    assetFieldKey: 'projectSfId',
    portalField: 'Project SF ID',
    portalFieldKey: 'projectSfId',
    required: false
  },
  {
    assetField: 'Next Steps',
    assetFieldKey: 'nextSteps',
    portalField: 'Next Steps',
    portalFieldKey: 'nextSteps',
    required: false
  },
  {
    assetField: 'Billing Commencement Date',
    assetFieldKey: 'billingCommencementDate',
    portalField: 'Billing Commencement Date',
    portalFieldKey: 'billingCommencementDate',
    required: false
  },
  {
    assetField: 'Estimated Delivery Date',
    assetFieldKey: 'estimatedDeliveryDate',
    portalField: 'Estimated Delivery Date',
    portalFieldKey: 'estimatedDeliveryDate',
    required: false
  },
  {
    assetField: 'Circuit Role',
    assetFieldKey: 'circuitRole',
    portalField: 'Circuit Role',
    portalFieldKey: 'circuitRole',
    required: false
  },
  {
    assetField: 'Renewal Language',
    assetFieldKey: 'renewalLanguage',
    portalField: 'Renewal Language',
    portalFieldKey: 'renewalLanguage',
    required: false
  },
  {
    assetField: 'Rack Type',
    assetFieldKey: 'rackType',
    portalField: 'Rack Type',
    portalFieldKey: 'rackType',
    required: false
  },
  {
    assetField: 'Equipment Details',
    assetFieldKey: 'equipmentDetails',
    portalField: 'Equipment Details',
    portalFieldKey: 'equipmentDetails',
    required: false
  },
  {
    assetField: 'Disconnected Reason',
    assetFieldKey: 'disconnectedReason',
    portalField: 'Disconnected Reason',
    portalFieldKey: 'disconnectedReason',
    required: false
  },
  {
    assetField: 'Access Type',
    assetFieldKey: 'accessType',
    portalField: 'Access Type',
    portalFieldKey: 'accessType',
    required: false
  },
  {
    assetField: 'Address Info',
    assetFieldKey: 'addressInfo',
    portalField: 'Address Info',
    portalFieldKey: 'addressInfo',
    required: false
  }
];
